import { render, staticRenderFns } from "./CloneDashboardModal.vue?vue&type=template&id=ef6493f4&scoped=true"
import script from "./CloneDashboardModal.vue?vue&type=script&lang=js"
export * from "./CloneDashboardModal.vue?vue&type=script&lang=js"
import style0 from "./CloneDashboardModal.vue?vue&type=style&index=0&id=ef6493f4&prod&scoped=true&lang=css"
import style1 from "./CloneDashboardModal.vue?vue&type=style&index=1&id=ef6493f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6493f4",
  null
  
)

export default component.exports